<template>
  <div>
    <cms-our-schools
      v-if="ourSchoolsSetUp"
      :theme="ourSchoolsOptions"
      :content="homepage.our_schools[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);
const isThemePreview = computed(() => store.state.isThemePreview);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const ourSchoolsOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: store.getters['translation/getComponentTranslation']('ourSchools'),
    globalThemeSettings: store.getters.getGlobalThemeSettings,
  };
});

const ourSchoolsSetUp = computed(() => !isEmpty(homepage.value?.our_schools?.[id.value]?.content));
</script>
